<template>
  <div class="productcenterhtml">
    <div class="productcenterhead">
      <div class="productcenterheadtext">
        <p
          style="
            float: left;
            font-size: 18px;
            color: #275479;
            font-weight: bold;
            line-height: 30px;
            margin-left: 3px;
          "
        >
          下单工具
        </p>
      </div>
    </div>
    <div class="productcenterbody">
      <div class="productcenterbodytag">
        <ul style="padding-top: 70px">
            <li class="pli" v-for="(item,index) in leftnav" :key="index">
                <div v-bind:class="[item.active ? class4 : class3]"></div>
                <div v-bind:class="[item.active ? class1 : class5]" @click="show(index)">
                    <div style="width: 45px; height: 40px; float: left"></div>
                    <div class="tagmid">{{item.text}}</div>
                    <div style="width: 30px; height: 40px; float: left"></div>
                </div>
                <div style="width: 9px; height: 7px; float: left;position:absolute;right:1px;bottom:-7px">
                    <img
                        src="../../assets/images/lan-jia.png"
                        style="display: block"
                        v-if="item.active"
                    />
                </div>
            </li>
        </ul>
      </div>
      <div style="height: 18px"></div>
      <div class="productcenterbodytext" ref="box">
        <div
          style="
            width: 780px;

            border-radius: 2%;
            position: relative;
          "
        >
          <div class="midtext">
            <div v-if="leftnav.filter((el)=>{return el.id=='dzh'})[0].active">
              <h4 class="head4" id="productcentertwo"></h4>
              <p class="pproduct">
                多账号下单工具能够满足机构同时对多个交易账号进行下单的使用场景。支持不同期货公司、不同交易后台（CTP、金仕达、恒生多种后台）同时登陆，可配置20个交易账号同时交易。不仅支持画线下单、多账号条件单、多账号止损单，像使用单个账号交易一样简单，还支持多账号套利交易、移仓交易、下单任务管理器、算法分批下单等多种机构交易工具。
              </p>
              <p class="pproduct">
                根据不同交易机构的使用场景，提供了“一带多模式”和“投资经理/交易员模式”两种下单模式。
              </p>
              <h5 class="head5">一带多模式：</h5>
              <p class="pproduct">
                适用于交易员一个人管理多个交易账号的使用场景，可一键同时对多个账号进行下单。支持按倍率或份数自动计算交易手数，并提供了三键下单和传统下单两种交易界面可供选择。
              </p>
              <BaseBigimg :src="require('@/../public/proimg/1多账号.jpg')"></BaseBigimg>
              <h5 class="head5">投资经理/交易员模式：</h5>
              <p class="pproduct">
                适用于投资经理只负责主账号交易，交易员管理其他多个账号跟随主账号交易的使用场景。交易员账号支持按照倍率自动同步投资经理账号的委托下单，交易员监控交易过程，可手动撤单、追价、同步持仓。
              </p>
              <BaseBigimg :src="require('@/../public/proimg/2多账号.jpg')"></BaseBigimg>
            </div>
            <div v-if="leftnav.filter((el)=>{return el.id=='rwglq'})[0].active">
              <h4 class="head4" id="productcenterthirteen">
               
              </h4>
              <p class="pproduct">
                添加多个下单任务，让软件自动监控价格，符合价格条件时自动执行下单任务，交易员只需关注交易日志和任务执行进度。
              </p>
              <!-- <h5 class="head5">智能分批降低冲击成本</h5> -->
              <p class="pproduct">
                下单任务管理器可智能分批降低冲击成本，根据不同合约的活跃程度，设定每批下单手数，在确保不破坏趋势的前提下，提高成交效率。同时还可添加偏离条件，当价格偏移过大时暂停交易，价格回归以后自动继续下单，以确保所有订单成交在相同的价格附近。
              </p>
              <BaseBigimg :src="require('@/../public/proimg/jyrw2.jpg')"></BaseBigimg>
            </div>
            <div v-if="leftnav.filter((el)=>{return el.id=='wjxd'})[0].active">
              <h4 class="head4" id="productcenterfifteen"></h4>
              <p class="pproduct">
                使用文件下单功能可以快速将Excel 或 Python 等文件生成 csv 格式交易指令转变为账户持仓。系统自动扫描文件发送委托、控制下单间隔，方便、快速、准确。
              </p>
              <p class="pproduct">
                使用步骤如下图所示：
              </p>
              <BaseBigimg :src="require('@/../public/proimg/wjxd2.jpg')"></BaseBigimg>
              <!-- <p class="pimg"><img src="@/../public/proimg/wjxd2.jpg" /></p> -->
            </div>
            <div v-if="leftnav.filter((el)=>{return el.id=='fpxd'})[0].active">
              <h4 class="head4" id="productcenterfourteen"></h4>
              <p class="pproduct">
                算法分批下单内置多种经典算法交易策略，只需填写参数即可使用策略，可自动监控行情变化、委托回报等交易信息，加强对交易过程的精细化控制，实现智能分批，达到减少成交滑点，提高交易效率的目的。
              </p>
              <p class="pproduct">
                文华原创期货算法策略“<strong>小鬼插队</strong>”，针对期货、期权合约的盘口流动性特点，根据盘口当时的实时情况，综合使用对手价、插队价方式智能分批下单（<a
                  href="https://www.wenhua.com.cn/popwin/7sfjy.htm"
                  class="eeee"
                  target="_blank"
                  >点击查看算法策略说明</a
                >）。
              </p>
              <p class="pimg" style="padding-bottom: 0">
                <BaseBigimg :src="require('@/../public/proimg/算法分批.jpg')"></BaseBigimg>
              </p>
              <p class="pproduct">
                软件还支持多账号算法拆单，且提供了多账号手数分配算法。交易员可根据合约盘口成交状态，确定并输入单批次委托手数，系统自动按照账号权重分配手数。
              </p>
              <p class="pimg" style="padding-bottom: 0">
                <BaseBigimg :src="require('@/../public/proimg/算法分批2.jpg')"></BaseBigimg>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      leftnav:[
      {active:true,text:'多账号下单',id:'dzh'},
      // {active:false,text:'产业数据',id:'cysj'},
      {active:false,text:'算法分批下单',id:'fpxd'},
      {active:false,text:'下单任务管理器',id:'rwglq'},
      {active:false,text:'文件下单',id:'wjxd'},
      ],
      class1: "onclick",
      class2: "noclick",
      class3: "touming",
      class4: "yellow",
      class5: "noclickone",
      class6: "noclickele",
    };
  },
  methods: {
    show(index){
        console.log()
        this.leftnav.forEach((el,idx)=>{
            el.active=false
        })
        this.leftnav[index].active=true
    },
    custormAnchor(anchorName) {
      // 找到锚点
      let anchorElement = document.getElementById(anchorName);
      console.log(anchorElement.scrollTop)
      // 如果对应id的锚点存在，就跳转到锚点
      if (anchorElement) {
        anchorElement.scrollIntoView();
      }
    },
   
  },
  mounted(){
    this.leftnav.forEach((el,idx)=>{
            el.active=false
    })
    this.leftnav.filter((el)=>{
      return el.id==this.$route.params.id
    })[0].active=true
    this.$nextTick(()=>{

      this.custormAnchor(this.$route.hash.split('#')[1]);
    })
  }

};
</script>

<style scoped>
.eeee {
  color: blue;
  text-decoration: none;
}
.eeee :visited {
  color: blue;
}
.productcenterhtml {
  background: url("../../assets/images/ts-bg_02.jpg") no-repeat top, #eef0ff;
  /* background-size: 100% 100%; */
  min-width: 1400px;
  width: 100%;
}
.productcenterhead {
  position: relative;
  height: 140px;
  width: 1000px;
  margin: 0 auto;
}
.productcenterheadtext {
  position: absolute;
  top: 105px;
  left: 3px;
}
.productcenterbody {
  width: 1000px;
  margin: 0 auto;
  position: relative;
}
.productcenterbodytag {
  width: 570px;
  height: 476px;
  border-radius: 2%;
  background: url("../../assets/images/ts-1_01.png") no-repeat center;
  /* background-size: 100% 100%; */
  position: absolute;
}
.productcenterbodytext {
  margin-left: 220px;
  width: 780px;
  border-top-left-radius: 1em;
  background: url("../../assets/images/ts-1_02.jpg") no-repeat top, #f7f7f7;
  background-size: 100%;
  overflow-x: hidden;
  filter: drop-shadow(1px 1px 2px #c2c5d4);
  min-height: 680px;
  z-index: 999;
}
.noclick {
  height: 41px;
  line-height: 41px;

  width: 220px;
  border-top: 1px solid #2f5476;
  letter-spacing: 1px;
  color: white;
  text-align: left;
  float: left;
  font-size: 14px;
  font-weight: normal;
  cursor: pointer;
}
.onclick {
  height: 42px;
  line-height: 42px;
  background: #fdfdfd;

  width: 220px;

  color: #395774;
  text-align: left;
  letter-spacing: 1px;

  float: left;
  font-size: 14px;
  font-weight: normal;
  cursor: pointer;
}
.touming {
  width: 5px;
  height: 42px;
  float: left;
}
.yellow {
  width: 5px;
  height: 42px;
  background: #e3a200;
  float: left;
  border-top-left-radius: 0.1em;
  border-bottom-left-radius: 0.1em;
}
.head4 {
  color: #245376;
  font-size: 16px;
  padding-top: 20px;
  padding-bottom: 10px;
  font-weight: bold;
  letter-spacing: 1px;
}
.midtext {
  width: 680px;
  margin: 0 auto;
  padding-bottom: 30px;
}
.pproduct {
  font-size: 15px;
  padding-top: 3px;
  padding-bottom: 3px;
  text-indent: 2em;
  color: #727983;
  line-height: 25px;
  /* width: 640px; */
  text-align: justify;
  letter-spacing: 1px;
}
.pimg {
  padding-top: 10px;
  padding-bottom: 10px;
  min-height: 50px;
  width: 100%;
  text-align: center;
}
.noclick:hover {
  color: #e3a200;
}
.pli {
  width: 235px;
  height: 42px;
  margin-left: -5px;
  position: relative;
  z-index: 88;
}
.noclickone {
  height: 41px;
  line-height: 41px;

  letter-spacing: 1px;
  width: 220px;

  border-top: 1px solid #2f5476;
  color: white;
  text-align: left;
  float: left;
  font-size: 14px;
  font-weight: normal;
  cursor: pointer;
}
.pli:last-child .noclickone{
  border-bottom: 1px solid #2f5476;
}
.noclickele {
  height: 40px;
  line-height: 40px;

  letter-spacing: 1px;
  width: 220px;
  border-top: 1px solid #2f5476;
  border-bottom: 1px solid #2f5476;
  color: white;
  text-align: left;
  float: left;
  font-size: 14px;
  font-weight: normal;
  cursor: pointer;
}
.noclickone:hover {
  color: #f59726;
}
.noclickele:hover {
  color: #f59726;
}
.tagmid {
  width: 130px;
  height: 42px;
  float: left;
  font-weight: bold;
}
.head5 {
  color: #245376;
  font-size: 15px;
  padding-top: 10px;
  padding-bottom: 10px;
  font-weight: bold;
  letter-spacing: 1px;
}
</style>